import { render, staticRenderFns } from "./CClone.vue?vue&type=template&id=02545ce2&lang=pug"
import script from "./CClone.vue?vue&type=script&lang=js"
export * from "./CClone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports